import { computed } from 'vue';
import { type RouteRecordRaw } from 'vue-router';

import { useGlobalI18n } from '@abaninja/util-i18n';

const { global: { t } } = useGlobalI18n();

export const routes: RouteRecordRaw[] = [
  {
    path: 'settings',
    children: [
      {
        name: 'settings',
        path: '',
        component: () => import('../SettingsIndex.vue'),
        children: [
          {
            name: 'settings-company-profile',
            path: 'company-profile',
            component: () => import('../components/CompanyProfileIndex.vue'),
            meta: {
              permissions: ['ADMIN'],
              title: computed(() => t('messages.companyProfile')),
            },
          },
          {
            name: 'settings-user-management',
            path: 'user-management',
            component: () => import('../components/UserManagementIndex.vue'),
            meta: {
              permissions: ['ADMIN'],
              title: computed(() => t('messages.userManagement')),
            },
          },
          {
            name: 'settings-users',
            path: 'users',
            component: () => import('../components/UserIndex.vue'),
            meta: {
              title: computed(() => t('messages.user')),
            },
          },
          {
            name: 'settings-security',
            path: 'security',
            component: () => import('../components/SecurityIndex.vue'),
            meta: {
              permissions: ['OWNER'],
              title: computed(() => t('messages.security')),
            },
          },
          {
            name: 'settings-ownership',
            path: 'ownership',
            component: () => import('../components/OwnershipIndex.vue'),
            meta: {
              permissions: ['OWNER'],
              title: computed(() => t('messages.ownership')),
            },
          },
        ],
      },
      {
        name: 'settings-user-management-form-old',
        path: 'user-management/user',
        redirect: { name: 'settings-user-invitation-form' },
      },
      {
        name: 'settings-user-management-form',
        path: 'user-management/user/:uuid',
        props: true,
        component: () => import('../components/EnabledUsers/UserForm.vue'),
      },
      {
        name: 'settings-user-invitation-form',
        path: 'user-management/invitation',
        props: true,
        component: () => import('../components/EnabledUsers/InvitationForm.vue'),
      },
      {
        name: 'settings-digital-coach-form',
        path: 'user-management/digital-coach',
        props: true,
        component: () => import('../components/DigitalCoach/DigitalCoachForm.vue'),
      },

      {
        name: 'settings-transfer-ownership',
        path: 'ownership/transfer',
        component: () => import('../components/TransferOwnership/TransferOwnershipIndex.vue'),
        meta: {
          permissions: ['OWNER'],
          title: computed(() => t('messages.transferOwnership')),
        },
      },
    ],
  },
];
